import type {
  CreateGroupModalPayload,
  DeleteGroupModalPayload,
  EditGroupModalPayload
} from '@space-core/components/groupModal/types'
import useMutation from '@space-shell/common/hooks/useMutation'
import { CommunitiesService } from '@space-shell/common/services/communities'

export const useCreateGroupCommunity = () => ({
  createGroupMutation: useMutation((group: CreateGroupModalPayload) =>
    CommunitiesService.createGroupCommunity(group)
  ),
  editGroupMutation: useMutation((group: EditGroupModalPayload) =>
    CommunitiesService.editGroupCommunity(group)
  ),
  deleteGroupMutation: useMutation(({ groupId, slug }: DeleteGroupModalPayload) =>
    CommunitiesService.deleteGroupCommunity(groupId, slug)
  )
})
